import React from 'react';
import { Button, Form, Input, Row, Col, Checkbox, Modal } from 'antd';
import { withTranslation } from "react-i18next"
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import axios from 'axios';
import JSEncrypt from "jsencrypt";
import { setAccessToken } from '../../utils/tokenUtils';
import config from '../../utils/config';
import UserAgreement from './userAgreement';
import PrivacyAgreement from './privacyAgreement';
import { openErrorMsg, getLang } from '../../utils/messageUtils';
import { defaultLanguageApi } from '../../utils/utils';

const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};
const { Password } = Input
class LoginUserForm extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            publicKey:'',
            captchaKey:'',
            captchaImg:'',
            phoneCaptchaKey:'',
            phone:'',
            isLogin: true,
            isModalOpen: false,
        }
    }
    
    formRef = React.createRef()
    componentDidMount() {
        this.getCaptcha()
        this.getPublicKey()
    }

    handleOpenModal = () =>{
        this.setState({ isModalOpen: true })
    }

    handleCloseModal = () =>{
        this.setState({ isModalOpen: false })
    }


    /**
     * 获取公钥
     */
    getPublicKey = () =>{
        axios
      .get(`${config.API_HOST}/hpfm/v1/tool/pass/public-key`)
      .then((result) => {
        // result.data才是真正的返回结果
        console.log(result.data);
        const {data} = result;
        this.setState({
            publicKey: data.publicKey || ''
        });
      })
      .catch((err) => {
        console.log(err);
      });
    }

    /**
     * 获取图片验证码
     */
    getCaptcha = () =>{
        axios
        .get(`${config.API_HOST}/oauth/public/captcha-code`)
        .then((result) => {
            this.setState({captchaKey:result.data.captchaKey})
            axios
            .get(`${config.API_HOST}/oauth/public/captcha/${result?.data?.captchaKey}`,{responseType: 'arraybuffer'})
            .then((res) => {
                let url = 'data:image/png;base64,' + btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
                this.setState({captchaImg:url})
            })
            .catch((err) => {
                console.log(err);
            });
        })
        .catch((err) => {
            console.log(err);
        });
    }

    /**
     * 密码加密
     * @param {*} password 
     * @returns 
     */
    encryptPwd = (password) => {
        // 有公钥 使用 rsa 加密
        if (this.state.publicKey) {
            // 初始化加密器
            const encrypt = new JSEncrypt(); // 设置公钥
            encrypt.setPublicKey(this.state.publicKey); // 加密
            return encrypt.encrypt(password);
        } else {
            return password;
        }
    }

    /**
     * 登录跳转
     */
    jumpUrl = async(loginRes) =>{
        setAccessToken(loginRes?.access_token);
        const tokenInfo = `#access_token=${loginRes.access_token}&token_type=${loginRes.token_type}&expires_in=${loginRes.expires_in}&refresh_token=${loginRes.refresh_token}&scope=${loginRes.scope}`;
        let jumpUrl = '/app/workplace';
        // window.location.href = `http://localhost:8000${jumpUrl}${tokenInfo}`;
        window.location.href = `${config.DOMAIN_NAME}${jumpUrl}${tokenInfo}`;
    }

    /**
     * 账号密码登录
     * @param {*} values 
     */
    onFinish = async (values) => {
        const data = {
            grant_type:'password',
            client_id:'client',
            client_secret:'secret',
            source_type:'web',
            device_id: new Date().getTime(),
            captcha:values.captcha,
            captchaKey: this.state.captchaKey,
            username:values.username,
            password:this.encryptPwd(values.password),
            lang: getLang(),

        }
        axios
        .post(`${config.API_HOST}/oauth/oauth/token`,data, {
            headers: {
                "Content-type": "application/x-www-form-urlencoded"
            }
          })
        .then(async(result) => {
            const loginRes = result.data;
            await defaultLanguageApi(loginRes?.access_token);
            await this.jumpUrl(loginRes);
        }) 
        .catch((err) => {
            //登录失败刷新验证码
            this.getCaptcha();
            const data = err.response.data;
            openErrorMsg(this.props.t('tips', { defaultValue: '提示' }), data.message);
        }); 
    }

    boxChange = (e) =>{
        this.setState({isLogin: !e.target.checked})
    }
 
    toHome = () =>{
        this.props.history.push('/home');
    }

    passwordFind = () =>{
        this.props.history.push('/passwordFind');
    }
    handlePrivacyModal =()=>{
        this.setState({isPrivacyModal:!this.state.isPrivacyModal})
    }

    render() {
        return (
            <div className="login-form-user">
                <Form
                    {...layout}
                    name="basic"
                    size='large'
                    ref={this.formRef}
                    onFinish={this.onFinish.bind(this)}
                >
                    <Form.Item  name="username" rules={[{ required: true, message: this.props.t('usernamePlaceholder', { defaultValue: '请输入账号' }) }]}>
                        <Input prefix={<UserOutlined />} placeholder={this.props.t('usernamePlaceholder', { defaultValue: '请输入账号' })} />
                    </Form.Item>
                    <Form.Item  name="password" rules={[{ required: true, message: this.props.t('passwordPlaceholder', { defaultValue: '请输入密码' }) }]}>
                        <Password visibilityToggle={false} prefix={<LockOutlined />} placeholder={this.props.t('passwordPlaceholder', { defaultValue: '请输入密码' })} />
                    </Form.Item>
                    <Form.Item rules={[{ required: true, message: this.props.t('captchaPlaceholder', { defaultValue: '请输入验证码' }) }]} >
                        <Row gutter={8}>
                        <Col span={18}>
                            <Form.Item
                            name="captcha"
                            noStyle
                            rules={[{ required: true, message: this.props.t('captchaPlaceholder', { defaultValue: '请输入验证码' }) }]}
                            >
                            <Input style={{height:50}} />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <img width={122} height={50} src={this.state.captchaImg} onClick={this.getCaptcha.bind(this)} alt='' />
                        </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item>
                        <Form.Item name="remember" valuePropName="checked" noStyle>
                            <Checkbox onChange={this.boxChange.bind(this)}>{ this.props.t('readCheckbox', { defaultValue: '我已阅读并同意' }) }</Checkbox>
                        </Form.Item>

                        {/*  eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a className="login-form-forgot" onClick={this.handleOpenModal}>
                            { this.props.t('agreement', { defaultValue: '《用户许可协议》' }) }
                        </a>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a style={{marginLeft:10}} className="login-form-forgot" onClick={this.handlePrivacyModal}>
                            { this.props.t('privacyAgreement', { defaultValue: '《隐私协议》' }) }
                        </a>
                        <span onClick={this.passwordFind.bind(this)} style={{float: 'right'}}> { this.props.t('forgotPassword', { defaultValue: '忘记密码' }) }</span>
                    </Form.Item>
                
                    <div>
                        <Form.Item className="">
                            <Button disabled={this.state.isLogin} type="primary" htmlType="submit" loading={this.state.loading} className="login-form-button">{ this.props.t('login', { defaultValue: '登录' }) }</Button>
                            <span onClick={this.toHome.bind(this)} className='to-home'>{ this.props.t('goHome', { defaultValue: '返回首页' }) }</span>
                        </Form.Item>
                    </div>
                </Form>
               

                <Modal 
                    className='agreement-modal' 
                    width={800}
                    open={this.state.isModalOpen} 
                    onCancel={this.handleCloseModal}
                    footer={[
                        <Button key="submit" type="primary" onClick={this.handleCloseModal} >
                           { this.props.t('close', { defaultValue: '关闭' }) }
                        </Button>,
                      ]}
                >
                    <UserAgreement />
                </Modal>
                {
                  this.state.isPrivacyModal && (
                    <Modal 
                        className='privacy-agreement-modal' 
                        width={900}
                        open={this.state.isPrivacyModal} 
                        onCancel={this.handlePrivacyModal}
                        footer={[
                        <Button key="submit" type="primary" onClick={this.handlePrivacyModal} >
                        { this.props.t('close', { defaultValue: '关闭' }) }
                        </Button>,
                        ]}
                    >
                        <PrivacyAgreement show={this.state.isPrivacyModal} />
                    </Modal>
                  ) 
                }
                
            </div>
        )
    }
}

export default LoginUserForm = withTranslation()(LoginUserForm);